import * as React from 'react';

import { cn } from '@/lib/utils';
import { Label } from './label';

interface InputProps extends React.ComponentProps<'input'> {}

function Input({ className, type, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  );
}

interface InputWithLabelProps extends InputProps {
  label: string;
  error?: boolean;
  helperText?: string;
}

function InputWithLabel({
  label,
  id,
  error,
  helperText,
  className,
  ...props
}: InputWithLabelProps) {
  return (
    <div className={cn('grid w-full max-w-sm items-center gap-3', className)}>
      <Label htmlFor={id}>{label}</Label>
      <div className="flex flex-col gap-1">
        <Input {...props} />
        {error && <p className="text-red-500 text-xs">{helperText}</p>}
      </div>
    </div>
  );
}

export { Input, InputWithLabel };
